import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
const StyledHorizontalDivider = styled('div', {
    width: '100%',
    height: sizes.divider.thickness,
    backgroundColor: staticColors.divider,
    alignSelf: 'center',
});
export const HorizontalDivider = () => _jsx(StyledHorizontalDivider, {});
